import React, {Component} from 'react';
import {} from '@material-ui/core';

class CallErrorPage extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	componentDidMount = () => {
	}

	render() {
		return (
			<div>
				{{}.map((t) => (
					<></>
				))}
			</div>
		);
	}
}

export default CallErrorPage
